import {SecondaryButton} from 'components';
import React from 'react';
import Chart from 'react-apexcharts';

function IdentityVerificationChart() {
  const state = {
    series: [
      {name: 'BVN (BASIC)', data: [95, 90, 96, 95, 94, 95, 96]},
      {name: 'BVN (ADVANCE)', data: [165, 175, 165, 164, 165, 166, 165]},
      {name: 'NIN', data: [272, 274, 273, 274, 273, 274, 272]},
      {name: 'VNIN', data: [95, 95, 96, 95, 94, 95, 96]},
      {name: 'PHONE NUMBER (BASIC)', data: [60, 65, 88, 89, 78, 82, 90]},
      {
        name: 'PHONE NUMBER (ADVANCE)',
        data: [272, 274, 273, 274, 273, 274, 271],
      },
      {name: 'NUBAN', data: [95, 68, 96, 95, 94, 95, 295]},
      {name: 'NUBAN KYC', data: [80, 70, 85, 90, 80, 75, 95]},
      {name: 'CAC', data: [50, 45, 60, 55, 65, 70, 80]},
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {show: false},
        background: '#FFFFFF',
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '85%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {enabled: false},
      stroke: {show: true, width: 4, colors: ['transparent']},
      xaxis: {
        categories: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL'],
        labels: {style: {colors: '#6E6E6E', fontSize: '12px'}},
        axisBorder: {show: false},
        axisTicks: {show: false},
      },
      yaxis: {
        labels: {style: {colors: '#6E6E6E', fontSize: '12px'}},
        axisBorder: {show: false},
        axisTicks: {show: false},
      },
      fill: {opacity: 1},
      grid: {
        show: true,
        borderColor: '#F9F9F9',
        strokeDashArray: 0,
        position: 'back',
        xaxis: {lines: {show: false}},
        yaxis: {lines: {show: true}},
        padding: {left: 0, right: 0},
      },
      legend: {
        show: false,
      },
      colors: [
        '#0D192C',
        '#87D4DB',
        '#3F7CDB',
        '#FF5C5C',
        '#2B5125',
        '#DC6803',
        '#23F9F0',
        '#55A249',
        '#5A120C',
      ],
    },
  };

  const legendData = state.series.map((item, index) => ({
    label: item.name,
    color: state.options.colors[index],
  }));

  return (
    <div className="bg-white mt-5 h-full shadow-cards rounded-xl border-[0.5px] border-[#EFEFEF]">
      <div className="bg-[#F9F9F9] py-3 px-6 rounded-t-xl">
        <p className="font-medium text-sm xl:text-base text-deepBlue">
          Identity Verification
        </p>
      </div>
      <div className="flex flex-wrap gap-4 items-center justify-between p-6">
        <div className="flex flex-wrap gap-x-4 gap-y-2">
          {legendData.map((item, index) => (
            <div key={index} className="flex items-center space-x-2">
              <span
                className="w-2 h-2 rounded-full"
                style={{backgroundColor: item.color}}
              ></span>
              <span className="text-[9px] text-[#0B1C56] font-normal capitalize">
                {item.label}
              </span>
            </div>
          ))}
        </div>

        <SecondaryButton buttonText="Filter" />
      </div>

      <Chart
        options={state.options}
        series={state.series}
        type="bar"
        height={350}
      />
    </div>
  );
}

export default IdentityVerificationChart;
